var DeleteAccountEnum = /* @__PURE__ */ ((DeleteAccountEnum2) => {
  DeleteAccountEnum2["DELETE_ACCOUNT_PASSWORD_INPUT"] = "delete-account--password-input";
  DeleteAccountEnum2["DELETE_ACCOUNT_SUBMIT_BUTTON"] = "delete-account--submit-button";
  DeleteAccountEnum2["DELETE_ACCOUNT_CONFIRM_SHEET"] = "delete-account--confirm-sheet";
  DeleteAccountEnum2["DELETE_ACCOUNT_CONFIRM_BUTTON"] = "delete-account--confirm-button";
  DeleteAccountEnum2["DELETE_ACCOUNT_CANCEL_BUTTON"] = "delete-account--cancel-button";
  return DeleteAccountEnum2;
})(DeleteAccountEnum || {});
export {
  DeleteAccountEnum
};
